
    <div class="row m-0 p-0">

        <div class="col-md-12">
            <div class="closebtn hardclose" (click)="close()">
                <span class="material-icons">
                    close
                </span>
            </div>
            <div class="row">
                <div class="col-md-12">

                    <form [formGroup]="devlieryDateForm" >
                        <div class="form_full_course">
        
                           <h3>Fill the Details
                            </h3>
        
                            <div class="enq_filds">
                                <mat-form-field class="example-full-width">
                                    <input type="text" matInput formControlName="name" placeholder="Name">                                    
                                </mat-form-field>
                            </div>

                            <div class="enq_filds">
                                <mat-form-field class="example-full-width">
                                    <input type="text" matInput formControlName="phone_no" placeholder="Phone">                                    
                                </mat-form-field>
                            </div>
                            <div class="enq_filds">
                                <mat-form-field class="example-full-width">
                                    <input type="text" matInput formControlName="mail_id" placeholder="Email ID">                                    
                                </mat-form-field>
                            </div>

                            <button class="mt-3"  mat-flat-button color="primary"
                                (click)="save()">Submit</button>
        
                        </div>
                    </form>
                </div>

                
            </div>
           

        </div>

    </div>
